import React, { createContext, useContext, useState } from 'react';

interface BackupModalContextType {
  isBackupModalOpen: boolean;
  openBackupModal: () => void;
  closeBackupModal: () => void;
}

const BackupModalContext = createContext<BackupModalContextType | undefined>(undefined);

interface BackupModalProviderProps {
  children: React.ReactNode;
}

export const BackupModalProvider: React.FC<BackupModalProviderProps> = ({ children }) => {
  const [isBackupModalOpen, setIsBackupModalOpen] = useState(false);

  const openBackupModal = () => {
    setIsBackupModalOpen(true);
  };

  const closeBackupModal = () => {
    setIsBackupModalOpen(false);
  };

  return (
    <BackupModalContext.Provider value={{ isBackupModalOpen, openBackupModal, closeBackupModal }}>
      {children}
    </BackupModalContext.Provider>
  );
};

export const useBackupModal = (): BackupModalContextType => {
  const context = useContext(BackupModalContext);
  if (context === undefined) {
    throw new Error('useBackupModal must be used within a BackupModalProvider');
  }
  return context;
}; 